import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useEffect } from "react";
export default function MessageTextSelect({
  parentCallback,
  LanguageData,
  MST,
}) {
  const [list, setlist] = useState();
  // const [list1, setlist1] = useState();
  const [disabledState, setDisableState] = useState(false);

  // useEffect(() => {
  //   if (MST?.id != undefined) {
  //     setDisableState(true);
  //     setlist({
  //       id: MST?.langid,
  //       lang: MST?.lang,
  //     });
   
  //   }
  // }, [MST]);
  // console.log("targeted", MST);

  // const handlechange = (value) => {

  //   setlist(value);
  //   setlist1(value);
  // };
  const x = useSelector((state) => state.campaignReducer.campaignState);
  useEffect(() => {
    setlist(null);
  }, [x]);
  React.useEffect(() => {
    // if (MST?.id != undefined) {
    //   parentCallback(list1);
    // } else {
    //   parentCallback(list);

    // }
        parentCallback(list);

  }, [list]);

  return (
    <Autocomplete
      disablePortal
      // disabled={disabledState == true ? true : false}
      aria-required
      className="w-100"
      id="combo-box-demo"
      size="small"
      options={LanguageData}
      getOptionLabel={(option) => option.lang || ""}
      value={list}
      // value={list1==undefined ?list:list1}
      // value={list1?.lang == null ? list : list1}
      // onChange={(e, value) => handlechange(value)}
      onChange={(e, value) => {
        // console.log("vlue--", value);
        setlist(value);
        // setlist1(value);
        // setlist1({
        //   id: value?.id,
        //   lang: value?.lang,
        // });
      }}
      sx={{ width: 300 }}
      renderInput={(params) => (
        <TextField required {...params} label="Language" />
      )}
    />
  );
}

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top
// const top100Films = [
//   { label: "English", year: 0 },
//   { label: "Bangladesh", year: 1 },
// ];
